import { BitfDefaultResponseMapper } from '../default-parser/bitf-default-response.mapper';
export abstract class BitfNetResponseMapper extends BitfDefaultResponseMapper {}
